import React, { memo } from 'react';

// ═══════════════════════════════════════════════════════════════
// TOOLBAR BUTTON
// ═══════════════════════════════════════════════════════════════

function ToolbarBtnInner({
  icon,
  label,
  onClick,
  title,
  disabled = false,
  loading = false,
  active = false,
  variant = 'default',
  showIndicator = false,
  indicatorOn = false,
  className = '',
}) {
  return (
  <button 
    className={`toolbar-btn ${active ? 'toolbar-btn--active' : ''} ${disabled ? 'toolbar-btn--disabled' : ''} ${loading ? 'toolbar-btn--loading' : ''} ${variant !== 'default' ? `toolbar-btn--${variant}` : ''} ${className}`.trim()}
    onClick={onClick}
    title={title}
    disabled={disabled}
    aria-busy={loading || undefined}
  >
    <span className="toolbar-btn__content">
      <span className={`toolbar-btn__icon ${loading ? 'toolbar-btn__icon--loading' : ''}`.trim()}>{icon}</span>
      {label && <span className="toolbar-btn__label">{label}</span>}
    </span>
    {showIndicator && (
      <span className={`toolbar-btn__dot ${indicatorOn ? 'toolbar-btn__dot--on' : ''}`} />
    )}
  </button>
  );
}

export const ToolbarBtn = memo(ToolbarBtnInner);
ToolbarBtn.displayName = 'ToolbarBtn';

// ═══════════════════════════════════════════════════════════════
// OVERFLOW MENU ITEM
// ═══════════════════════════════════════════════════════════════

export const OverflowMenuItem = ({ icon, label, onClick, disabled, active, variant }) => (
  <button 
    className={`overflow-menu__item ${disabled ? 'overflow-menu__item--disabled' : ''} ${active ? 'overflow-menu__item--active' : ''} ${variant === 'danger' ? 'overflow-menu__item--danger' : ''}`}
    onClick={onClick}
    disabled={disabled}
  >
    <span className="overflow-menu__item-icon">{icon}</span>
    <span className="overflow-menu__item-label">{label}</span>
  </button>
);
